



















import {Component, Prop, Vue} from "vue-property-decorator";
import SessionListInfo from "@share/program/components/session-list/session-list-info/SessionListInfo.vue";
import CloseBtn from '@share/common/CloseBtn.vue';
import { Element } from "@api/models/Element";
import { Rating } from "@api/models/Rating";

@Component({
    name: 'SessionInfoModal',
    components: { SessionListInfo, CloseBtn }
})
export default class SessionInfoModal extends Vue {
    @Prop({ required: true }) session: Element;
    @Prop({default: null}) likesProp: Record<string, Rating> | null;
    @Prop({default: null}) commentsProp: Record<string, number> | null;
    @Prop({ default: true }) simpleMode: boolean;
}
